<app-kontable
    *ngIf="columnsTitles"
    id="card-homing-table"
    #table
    title = "{{ 'cardHoming.title' | translate }}"
    [columns] = "[
    'id',
    'card_no',
    'card_no_start',
    'card_no_end',
    'store_from',
    'store_to',
    'flg_dpl'
    ]"
    [titles] = "[
    columnsTitles.id,
    columnsTitles.card_no,
    columnsTitles.card_no_start,
    columnsTitles.card_no_end,
    columnsTitles.store_from,
    columnsTitles.store_to,
    columnsTitles.flg_dpl
    ]"
    [paginationType]="paginationType"
    [showInfoButton]="false"
    [showRecoverButton]="false"
    [showGlobalFilter]="false"
    [showEditButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showReport]="false"
    [service]="cardHomingService"
    [(fireNewDataAvailable)]="newDataAvailable"
    [additionalRowCommands]="customButton"
    [showCardHomingBtns]="true"
    (cardHomingOperationType)="operationTypeHandler($event)"
>
  <ng-template #customButton data-testid="customButton" let-row>
    <p-button label="" icon="fa fas fa-rocket" styleClass="ui-button-info" *ngIf="row.flg_dpl === '0'"
              (onClick)="readyDeployHoming(row.id)" pTooltip="{{ 'card_batch.deploy' | translate }}"></p-button>
    <p-button label="" icon="fa fas fa-fast-backward" styleClass="ui-button-info" *ngIf="row.flg_dpl === '1'"
              (onClick)="resetDeployHoming(row.id)" pTooltip="{{ 'Reset' | translate }}"></p-button>
  </ng-template>
</app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-homing/loyalty-card-homing.component.html